<ng-container *ngIf="spoBoxes && spoBoxes[idx] && spoBoxes[idx][docCode]; else noSpoBoxes">
  <button 
    *ngIf="!data.areBoxesLoading()"
    class="nrk-button ml-2"
    (click)="refreshSelectStatus(boxesWindow, idx, docCode)">☰
  </button>
  <ngx-loading-spinner [loading]="data.areBoxesLoading()" [small]="true" label=""></ngx-loading-spinner>
  <!-- <button class="nrk-button ml-2" (click)="boxesWindow.toggle();">☰</button> -->

  <nrk-window #boxesWindow>
    <nrk-header>
      <b>Define Boxes from assigned PFSPO to OC</b><small class="ml-2 mr-2" style="font-size:smaller">(shift = multiselect)&nbsp;&nbsp;&nbsp;Current Document:</small><b>{{this.document.code}}</b>
    </nrk-header>
    <nrk-content>

      <!-- <ng-container *ngTemplateOutlet="markAsLost; context: {}"></ng-container> -->

      <div class="m-3" style="text-align:center;">
        <table class="nrk-table mt-2">
          <tr class="nrk-sticky-header">
            <th *ngIf="!disabled && (document.packingStatus < packingStatus.readyForDispatch || document.packingStatus >= packingStatus.exception)"></th>
            <th (click)="boxSort.col = 'boxId'; boxSort.dir = -boxSort.dir" class="small text-muted pseudo-link">Box ID&nbsp;{{getDirArrow('boxId')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'case'; boxSort.dir = -boxSort.dir">Case&nbsp;{{getDirArrow('case')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'spo'; boxSort.dir = -boxSort.dir">(PF)SPO&nbsp;{{getDirArrow('spo')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'spoPos'; boxSort.dir = -boxSort.dir">Pos&nbsp;{{getDirArrow('spoPos')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'quantity'; boxSort.dir = -boxSort.dir">Quantity&nbsp;{{getDirArrow('quantity')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'lot'; boxSort.dir = -boxSort.dir">Prod. Lot&nbsp;{{getDirArrow('lot')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'prodDate'; boxSort.dir = -boxSort.dir">Date of Prod.&nbsp;{{getDirArrow('prodDate')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'tc'; boxSort.dir = -boxSort.dir">TC #&nbsp;{{getDirArrow('tc')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'tcDate'; boxSort.dir = -boxSort.dir">Date of TC&nbsp;{{getDirArrow('tcDate')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'boxStatus'; boxSort.dir = -boxSort.dir">Status&nbsp;{{getDirArrow('boxStatus')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'docRef'; boxSort.dir = -boxSort.dir">Document&nbsp;{{getDirArrow('docRef')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'docRefPos'; boxSort.dir = -boxSort.dir">Pos&nbsp;{{getDirArrow('docRefPos')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'palletRef'; boxSort.dir = -boxSort.dir">Pallet ID&nbsp;{{getDirArrow('palletRef')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'dispatchDate'; boxSort.dir = -boxSort.dir">Dispatch date&nbsp;{{getDirArrow('dispatchDate')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'palletised'; boxSort.dir = -boxSort.dir">Palletised&nbsp;{{getDirArrow('palletised')}}</th>
            <th class="pseudo-link" (click)="boxSort.col = 'dnStatus'; boxSort.dir = -boxSort.dir">DN Status&nbsp;{{getDirArrow('dnStatus')}}</th>
          </tr>
          <ng-container *ngFor="let box of getDisplayBoxes(spoBoxes[idx][docCode]); index as row">
            <tr [ngStyle]="{ 
                'background-color': ['#9f9', '#8ef','#acf', '#ddd', '#fd8', '#f77', '#faf'][box.status], 
                'opacity': checkboxEnabled(box, item, true, true) ? 0.5 : 1,
                'font-weight': box.docRef === this.tree.linkedOC?.code ? 'bold' : 'normal'
                }">
              <td *ngIf="!disabled && (document.packingStatus < packingStatus.readyForDispatch || document.packingStatus >= packingStatus.exception)">
                <!-- <input type="checkbox" [(ngModel)]="box.selected" (change)="onBoxesCheckboxChange(spoBoxes[idx][docCode], row, $event)"/> -->
                <ngx-doc-form-checkbox *ngIf="checkboxEnabled(box, item)" [disabled]="checkboxEnabled(box, item, true)" [withEvent]="true" [value]="box.selected" (valueWithEventChange)="onBoxesCheckboxChange(getDisplayBoxes(spoBoxes[idx][docCode]), row, $event, item)"></ngx-doc-form-checkbox>
              </td>
              <td class="text-center small text-muted">{{box.boxId}}</td>
              <td class="text-center">{{box.case}}</td>
              <td class="text-center">{{box.spo}}</td>
              <td class="text-center">{{data.getPos(box.spo, box.spoPos)}}</td>
              <td class="text-right">{{box.quantity}}</td>
              <td class="text-center">{{box.lot?.join(', ')}}</td>
              <td class="text-center">{{box.prodDate?.join(', ')}}</td>
              <td class="text-center">{{box.tc?.join(', ')}}</td>
              <td class="text-center">{{box.tcDate?.join(', ')}}</td>
              <td class="text-center">{{boxStatus[box.status]}}</td>
              <td class="text-center">{{box.docRef}}</td>
              <td class="text-center">{{data.getPos(box.docRef, box.docRefPos)}}</td>
              <td class="text-center">{{box.palletRef}}</td>
              <td class="text-center">{{box.dispatchDate | date : 'yyyy-MM-dd'}}</td>
              <td class="text-center">{{box.status >= 2 ? 'yes' : ''}}</td>
              <td class="text-center">{{statusText(box.dnStatus)}}</td>
            </tr>
          </ng-container>
        </table>
      </div>
    </nrk-content>
    <nrk-footer>
      <div class="text-center" *ngIf="disabled || document.packingStatus >= packingStatus.readyForDispatch">
        <button class="nrk-button mr-3" (click)="boxSort.col='prodDate';boxSort.dir=1">Sort by Standard</button>
        <button *ngIf="['OC', 'CN'].includes(typeData.get(this.document.type).code) && !markAsExceptionEnabled" class="nrk-button mr-3" (click)="markAsException()">Mark as Exception</button>
        <div style="display:inline-block"><ngx-doc-form-checkbox label="Only show current OC" [(value)]="filterCurrentOC"></ngx-doc-form-checkbox></div>
      </div>
      <div *ngIf="!isFromSpo && !disabled && document.packingStatus >= packingStatus.readyForDispatch" class="text-center mt-2">
        <span *ngIf="document.packingStatus !== packingStatus.exception">No edit possible as </span>
        <span *ngIf="document.packingStatus === packingStatus.exception">Edit limited as packing </span>
        <div style="width:10rem;display:inline-block"><ngx-dn-status [compilation]="document"></ngx-dn-status></div>
      </div>
      <div *ngIf="!isFromSpo && !disabled && (document.packingStatus < packingStatus.readyForDispatch || document.packingStatus >= packingStatus.exception)" 
        class="text-center mt-2">
        Selected<b class="ml-2 mr-2">Σ Boxes</b>
        {{getSumBoxesQuantity(spoBoxes[idx][docCode], item).selectedBoxes}}
        <b class="ml-3 mr-2">Σ Q</b>
        {{getSumBoxesQuantity(spoBoxes[idx][docCode], item).selectedQuantity}}
      </div>
      <!-- <div *ngIf="getSumBoxesQuantity(spoBoxes[idx][docCode]).selectedQuantity !== getSumBoxesQuantity(spoBoxes[idx][docCode]).assignedQuantity" class="text-center mt-2 text-muted">Assigned<b class="ml-2 mr-2">Σ Boxes</b>{{getSumBoxesQuantity(spoBoxes[idx][docCode]).assignedBoxes}}<b class="ml-3 mr-2">Σ Q</b>{{getSumBoxesQuantity(spoBoxes[idx][docCode]).assignedQuantity}}</div> -->
      <!-- <div class="text-center mt-2 text-muted">Free<b class="ml-2 mr-2">Σ Boxes</b>{{getSumBoxesQuantity(spoBoxes[idx][docCode]).freeBoxes}}<b class="ml-3 mr-2">Σ Q</b>{{getSumBoxesQuantity(spoBoxes[idx][docCode]).freeQuantity}}</div> -->
      <div class="text-center m-2" *ngIf="!isFromSpo && !disabled && (document.packingStatus < packingStatus.readyForDispatch || document.packingStatus >= packingStatus.exception)">
        <!-- <button class="nrk-button mr-3" (click)="boxSort.col='prodDate';boxSort.dir=1">Sort by Standard</button>
        <div style="display:inline-block;margin-right:2rem"><ngx-doc-form-checkbox label="Only show current OC" [(value)]="filterCurrentOC"></ngx-doc-form-checkbox></div> -->
        <button class="nrk-button" (click)="selectAllBoxes(spoBoxes[idx][docCode], true, item)">Select all</button>
        <button class="nrk-button ml-1" (click)="selectAllBoxes(spoBoxes[idx][docCode], false, item)">Select none</button>
        <button *ngIf="markAsExceptionEnabled" class="nrk-button ml-4" (click)="markAs(BoxStatusType.damaged)">Mark as Damaged</button>
        <button *ngIf="markAsExceptionEnabled" class="nrk-button ml-1" (click)="markAs(BoxStatusType.lost)">Mark as Lost</button>
        <button *ngIf="markAsExceptionEnabled" class="nrk-button ml-1" (click)="markAs(BoxStatusType.retesting)">Mark as Retesting</button>
        <button *ngIf="markAsExceptionEnabled" class="nrk-button ml-1" (click)="lotWin.open()">Mark by Lot#</button>
        <!-- <button class="nrk-button ml-4" (click)="assignBoxes(item, spo, spoBoxes[idx][docCode]); boxesWindow.hide()">Assign</button>
        <button class="nrk-button ml-4" (click)="assignBoxes(item, spo, spoBoxes[idx][docCode], true); boxesWindow.hide()">Free</button> -->
        <button class="nrk-button ml-4" (click)="commitBoxes(spoBoxes[idx][docCode], item); boxesWindow.hide()">Save</button>
        <button class="nrk-button ml-1" (click)="cancelEdit(); boxesWindow.hide();">Cancel</button>
      </div>  
    </nrk-footer>
  </nrk-window>
</ng-container>

<ng-template #noSpoBoxes>N/A</ng-template>

<!--<ng-template #markAsLost>
  <div *ngIf="['OC', 'CN'].includes(typeData.get(this.compilation.type).code)">
    <button class="nrk-button" (click)="markAsException()">Mark as Exception</button>
    <!~~ <div *ngIf="markAsLostEnabled">
    </div> ~~>
  </div>
</ng-template>-->

<nrk-window #lotWin>
  <nrk-header>Lot Selection</nrk-header>
  <nrk-content>
    <div class="m-3 d-flex align-items-center flex-column">
      <div class="d-flex justify-content-center gap-3 flex-column">
        <div *ngFor="let lot of lots">
          <ngx-doc-form-checkbox [(value)]="lot.selected" [label]="lot.name"></ngx-doc-form-checkbox>
        </div>
      </div>
      <div class="mt-3">
        <button class="nrk-button" (click)="markAs(BoxStatusType.damaged, lots)">Mark as Damaged</button>
        <button class="nrk-button ml-3" (click)="markAs(BoxStatusType.lost, lots)">Mark as Lost</button>
        <button class="nrk-button ml-3" (click)="markAs(BoxStatusType.retesting, lots)">Mark as Retesting</button>
      </div>
    </div>
  </nrk-content>
</nrk-window>
